module.exports = __webpack_public_path__ + "static/media/linkedin.9a1682ca.png";